import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLang } from "../../context/langProvider";
import { resetSubscription, setCompanyField, setUserField } from "../../redux/actions/subscriptionActions";
import "./styles.css";

// Components
import FormUserSubscription from "../../components/FormUserSubscription";
import CountrySelect from "../../components/CountrySelect";
import ImageUploader from "../../components/ImageUploader";
import FormServiceModal from "../../components/FormServiceModal";
import ListServices from "../../components/ListServices";
import VideoRecorder from "../../components/VideoRecorder";
import VideoUploader from "../../components/VideoUploader";
import CarouselControls from "../../components/CarouselControls";
import { deleteBlob, getBlob, saveBlob } from "../../utils/idbBlobStorage";
import { login } from "../../redux/actions/authActions";
import { useNavigate } from "react-router-dom";
import InfoDialog from "../../components/InfoDialog";

const Subscription = () => {

  const [step, setStep] = useState(1);
  const { t, lang } = useLang();
  const dispatch = useDispatch();
  const { user, company } = useSelector((state) => state.subscription);
  const { user: authUser } = useSelector((state) => state.auth);

  const services = useSelector((state) => state.service.services);
  const [logoFile, setLogoFile] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [currentUploadingFile, setCurrentUploadingFile] = useState("");
  const [showModalSuccess, setShowModalSucces] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;

  const navigate = useNavigate();

  useEffect(() => {
    if (authUser)
      navigate("/");
  }, [])
  const handleChange = (e) => {
    const { name, value } = e.target;
    dispatch(setUserField(name, value));
  };

  const handleCompanyChange = (e) => {
    const { name, value } = e.target;
    dispatch(setCompanyField(name, value));
  };

  const handleLogoChange = async (file) => {
    try {
      await saveBlob("monLogo", file);
      dispatch(setCompanyField("logo", "monLogo"));
      setLogoFile(file);

    } catch (err) {
      console.error("Erreur sauvegarde blob :", err);
      return;
    }

  };

  const addUser = async () => {
    console.log("fonction addUser appelée avec :", user);
    try {
      const metadata = {
        firstName: user.firstName || "",
        lastName: user.lastName || "",
        address: user.address || "",
        postalCode: user.postalCode || "",
        city: user.city || "",
        countryCode: user.countryCode || "",
        email: user.email || "",
        password: user.password || "",
        isProfessional: !!user.isProfessional,
        isProvider: !!user.isProvider,
        lang: lang || "fr",
      };

      if (user.isProfessional) {
        metadata.nameCompany = company.name || "";
        metadata.identifierCompany = company.identifier || "";
        metadata.descriptionCompany = company.description || "";
        metadata.isAddressCompanyIsUserAddress = !!company.isAddressSameAsUser;

        if (!company.isAddressSameAsUser) {
          metadata.addressCompany = company.address || "";
          metadata.postalCodeCompany = company.postalCode || "";
          metadata.cityCompany = company.city || "";
          metadata.countryCodeCompany = company.countryCode || "";
        }

        if (user.isProvider && services && services.length > 0) {
          metadata.services = services;
          console.log(metadata.services);
        }
      }

      const formData = new FormData();
      let fileNameToUpload = null;

      formData.append("metadata", JSON.stringify(metadata));
      fileNameToUpload = "Infos utilisateur";
      if (user.isProfessional) {
        const savedLogoBlob = await getBlob("monLogo");
        if (savedLogoBlob) {
          // Extraire le type MIME (ex: "image/png")
          const mimeType = savedLogoBlob.type || "image/png";
          const extension = mimeType.split("/")[1]; // ex: "png"

          // Construire dynamiquement le nom de fichier
          const logoFile = new File(
            [savedLogoBlob],
            `logo_${Date.now()}.${extension}`,
            { type: mimeType }
          );

          formData.append("logo", logoFile);
        }

      }
      if (user.isProfessional && user.isProvider) {
        const savedBlob = await getBlob("maVideo");
        if (savedBlob) {
          let extension = "webm";
          let mimeType = "video/webm";
          if (savedBlob.type === "video/mp4") {
            extension = "mp4";
            mimeType = "video/mp4";
          }
          const file = new File(
            [savedBlob],
            `video_presentation.${extension}`,
            { type: mimeType }
          );
          formData.append("videoPresentation", file);
          fileNameToUpload = file.name;

        }
      }
      for (let pair of formData.entries()) {
        console.log(pair[0] + ':', pair[1]);
      }

      // Création de la requête XMLHttpRequest
      const xhr = new XMLHttpRequest();

      xhr.upload.addEventListener("progress", (event) => {
        if (event.lengthComputable) {
          const percent = Math.round((event.loaded / event.total) * 100);
          setUploadProgress(percent);
        }
      });

      xhr.onreadystatechange = () => {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          if (xhr.status >= 200 && xhr.status < 300) {
            const data = JSON.parse(xhr.responseText);

            handleLogin();
            dispatch(resetSubscription());

            setShowModalSucces(true);
            // Tu peux passer à l'étape suivante ici
          } else {
            let errorMsg = `Erreur serveur: ${xhr.status}`;
            try {
              const errorData = JSON.parse(xhr.responseText);
              errorMsg = errorData.error || errorMsg;
            } catch { }
            console.error("Erreur lors de l'ajout:", errorMsg);
            alert(errorMsg);
          }
          // Réinitialise la progression
          setUploadProgress(0);
        }
      };

      xhr.open(
        "POST",
        `${apiUrl}/api/subscription/subscribe`
      );
      if (fileNameToUpload) {
        setCurrentUploadingFile(fileNameToUpload);
      } else {
        setCurrentUploadingFile(""); // Pas de fichier
      }

      xhr.send(formData);
    } catch (error) {
      console.error("Erreur lors de l'ajout de l'utilisateur:", error);
      alert(error.message);
      setUploadProgress(0);
    }
  };

  const handleLogin = async () => {
    try {
      await dispatch(login(user.email, user.password));
    } catch (err) {
      console.error(err.message);
    }
  };

  return (
    <main className="background-primary">
      <section className="section-subscription">
        <h1>{t("subscribe-free")}</h1>

        {step === 1 && (
          <>
            <h2>VOUS ÊTES</h2>
            <div className="container-section-subscription">
              <div className="input-form-subscription">
                <h3>Particulier ou Professionnel ?</h3>
                <div className="btns-form">
                  <button
                    onClick={() => {
                      dispatch(setUserField("isProfessional", false));
                      dispatch(setUserField("isProvider", false));
                      setStep(2);
                    }}
                  >
                    PARTICULIER
                  </button>
                  <button
                    onClick={() => {
                      dispatch(setUserField("isProfessional", true));
                      setStep(3);
                    }}
                  >
                    PROFESSIONNEL
                  </button>
                </div>
              </div>
            </div>
          </>
        )}

        {step === 2 && (
          <FormUserSubscription
            onNext={() => setStep(4)}
            onPrevious={() => setStep(1)}
          />
        )}

        {step === 3 && (
          <>
            <h2>VOUS ÊTES</h2>
            <div className="container-section-subscription">
              <div className="input-form-subscription">
                <h3>Simple client professionnel ou Prestataire ?</h3>
                <div>
                  <h4>Vous souhaitez développer votre chiffre d’affaires ?</h4>
                  <p>
                    Inscrivez-vous gratuitement sur notre plateforme en tant
                    que prestataire et proposez vos services à des milliers de
                    clients partout en Europe. Vous pourrez également répondre
                    facilement aux projets déposés par nos clients en choisissant
                    la formule la plus adaptée à vos besoins.
                  </p>
                  <p>
                    En tant que prestataire, vous bénéficiez aussi gratuitement
                    de toutes les fonctionnalités réservées aux clients, comme la
                    possibilité de déposer vos appels d’offres, que ce soit à titre
                    privé ou professionnel.
                  </p>
                </div>
                <div className="btns-form">
                  <button
                    onClick={() => {
                      dispatch(setUserField("isProvider", false));
                      setStep(2);
                    }}
                  >
                    CLIENT PRO
                  </button>
                  <button
                    onClick={() => {
                      dispatch(setUserField("isProvider", true));
                      setStep(2);
                    }}
                  >
                    PRESTATAIRE
                  </button>
                </div>
              </div>
            </div>
          </>
        )}

        {step === 4 && (
          <>
            <h2>VOS INFORMATIONS PERSONNELLES</h2>

            <div className="input-form">
              <p>{t("country")}</p>
              <CountrySelect
                value={user.countryCode}
                onChange={(value) =>
                  dispatch(setUserField("countryCode", value))
                }
              />
            </div>

            {[
              ["lastName", t("nom")],
              ["firstName", t("prenom")],
              ["address", t("address")],
              ["postalCode", t("postalCode")],
              ["city", t("city")],
            ].map(([name, label]) => (
              <div className="input-form" key={name}>
                <label htmlFor={name}>{label}</label>
                <input
                  type="text"
                  name={name}
                  id={name}
                  value={user[name]}
                  onChange={handleChange}
                />
              </div>
            ))}

            <div className="btns-container">
              <button type="button" onClick={() => setStep(2)}>
                {t("previous")}
              </button>
              <button
                type="button"
                onClick={() =>
                  !user.isProvider && !user.isProfessional
                    ? addUser()
                    : setStep(5)
                }
              >
                {t("next")}
              </button>
            </div>
          </>
        )}

        {step === 5 && (
          <>
            <h2>{t("your-company")}</h2>

            <ImageUploader
              label="VOTRE LOGO"
              value={logoFile}
              onChange={handleLogoChange}
            />

            {[
              ["name", t("company-name")],
              ["identifier", t("siret")],
              ["description", "Présentez votre entreprise en quelques phrases", "textarea"]
            ].map(([name, label, type = "text"]) => (
              <div className="input-form" key={name}>
                <label htmlFor={name}>{label}</label>
                {type === "textarea" ? (
                  <textarea
                    name={name}
                    id={name}
                    value={company[name]}
                    onChange={handleCompanyChange}
                    rows={10}
                  />
                ) : (
                  <input
                    type={type}
                    name={name}
                    id={name}
                    value={company[name]}
                    onChange={handleCompanyChange}
                  />
                )}
              </div>
            ))}

            <div>
              <p>
                L'adresse de l'entreprise est-elle identique à celle du compte
                utilisateur ?
              </p>
              <div className="radio-group">
                {[
                  [true, "Oui"],
                  [false, "Non"],
                ].map(([value, label]) => (
                  <label key={value.toString()}>
                    <input
                      type="radio"
                      name="isAddressSameAsUser"
                      value={value.toString()}
                      checked={company.isAddressSameAsUser === value}
                      onChange={() =>
                        dispatch(
                          setCompanyField("isAddressSameAsUser", value)
                        )
                      }
                    />
                    {label}
                  </label>
                ))}
              </div>
            </div>

            {company.isAddressSameAsUser === false && (
              <>
                {["address", "postalCode", "city"].map((name) => (
                  <div className="input-form" key={name}>
                    <label htmlFor={name}>{t(name)}</label>
                    <input
                      type="text"
                      name={name}
                      id={name}
                      value={company[name]}
                      onChange={handleCompanyChange}
                    />
                  </div>
                ))}

                <div className="input-form">
                  <p>{t("country")}</p>
                  <CountrySelect
                    value={company.countryCode}
                    onChange={(value) =>
                      dispatch(setCompanyField("countryCode", value))
                    }
                  />
                </div>
              </>
            )}

            <div className="btns-container">
              <button type="button" onClick={() => setStep(4)}>
                {t("previous")}
              </button>
              <button type="button" onClick={() => user.isProvider ? setStep(6) : addUser()}>
                {user.isProvider ? t("next") : "ENREGISTRER"}
              </button>
            </div>
          </>
        )}

        {step === 6 && (
          <div>
            <h2>
              🎥 Valorisez votre entreprise avec une vidéo de présentation
            </h2>
            <p>
              Une vidéo est le moyen le plus direct et efficace de présenter vos
              services et de montrer votre savoir-faire. Profitez de cette
              opportunité pour inspirer confiance et vous démarquer auprès de
              vos futurs partenaires et clients.
            </p>
            {
              company.modeSelectionVideo === "record" && (
                <div>
                  <VideoRecorder />
                  <button onClick={async () => { dispatch(setCompanyField("modeSelectionVideo", null)); await deleteBlob("maVideo"); }}>ANNULER</button>
                </div>
              )
            }
            {
              company.modeSelectionVideo === "upload" && (
                <div>
                  <VideoUploader />
                  <button onClick={async () => { dispatch(setCompanyField("modeSelectionVideo", null)); await deleteBlob("maVideo") }}>ANNULER</button>

                </div>
              )
            }
            {
              company.modeSelectionVideo === null && (
                <div>
                  <button onClick={() => { dispatch(setCompanyField("modeSelectionVideo", "record")) }}>ENREGISTRER UNE VIDEO</button>
                  <button onClick={() => { dispatch(setCompanyField("modeSelectionVideo", "upload")) }}>UPLOADER UNE VIDEO</button>

                </div>
              )
            }
            <div className="btns-container">
              <button type="button" onClick={() => setStep(5)}>
                {t("previous")}
              </button>
              <button type="button" onClick={() => setStep(7)}>
                {t("next")}
              </button>
            </div>
          </div>
        )}

        {step === 7 && (
          <>
            <div>
              <h2>GESTION DES SERVICES</h2>
              {
                services && services.length === 0 && (
                  <>
                    <p style={{ color: "white" }}>Aucun service ajouté pour le moment.</p>

                    <CarouselControls
                      onNext={() => { }}
                      onPrev={() => { }}
                      onAdd={() => setShowModal(true)}
                      isPrevDisabled={true}
                      isNextDisabled={true}
                    />
                    {
                      showModal && (
                        <FormServiceModal onClose={() => setShowModal(false)} />
                      )
                    }

                  </>

                )
              }

              {
                services && services.length > 0 && (
                  <ListServices />
                )
              }



            </div>
            <div className="btns-container">
              <button type="button" onClick={() => setStep(6)}>
                {t("previous")}
              </button>
              <button type="button" onClick={() => addUser()}>
                ENREGISTRER
              </button>
            </div>
          </>
        )}
      </section>
      {
        showModalSuccess && (
          <InfoDialog open={true} title="Inscription réussie" message={"Votre inscritption a bien été prise en compte et vous êtes actuellement connecté"} onClose={() => navigate("/")} onConfirm={() => navigate("/")} />
        )
      }
      {uploadProgress > 0 && (
        <div style={{ marginTop: "1rem" }}>
          <p>Envoi en cours {currentUploadingFile}: {uploadProgress}%</p>
          <div
            style={{
              width: "100%",
              background: "#ddd",
              height: "8px",
              borderRadius: "4px",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                width: `${uploadProgress}%`,
                background: "#4caf50",
                height: "100%",
                transition: "width 0.2s",
              }}
            />
          </div>
        </div>
      )}

    </main>
  );
};

export default Subscription;
